async function ReCalculateDesign(designid) {

    if (designid.length > 0) {

        let response;

        response = await fetch("https://api.cssi.co/CNF/RecalculateDesign", {
            method: "POST",
            body: JSON.stringify(
                {
                    "designId": designid
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default ReCalculateDesign;